import gsap from 'gsap';

const init = (isRM) => {
  const homeHero = document.querySelector('.home-hero');

  if (!homeHero) return;

  gsap.set(['.home-hero__jumper', '.home-hero__play'], { autoAlpha: 1 });

  // Needed to prevent bug that only happens at 1297px wide.
  gsap.set('.home-hero__jumper', { xPercent: -50, x: 0 });

  const heroTL = gsap
    .timeline({ delay: 1 })
    .to('.home-hero__wrapper', { autoAlpha: 1, duration: 1 })
    .from(
      '.home-hero__hero-text-graphic',
      {
        opacity: 0,
        yPercent: 25,
        scale: 0.7,
        duration: 1.5,
        ease: 'sine.inOut'
      },
      0
    )
    .from(
      '.home-hero__jumper',
      { duration: 1.5, scale: 0.2, yPercent: 60, ease: 'sine' },
      0
    )
    .to(
      '.home-hero__bg',
      {
        scale: 1.5,
        duration: 14,
        ease: 'sine.out'
      },
      0
    )
    .from(
      ['.home-hero__text', '.home-hero__cta'],
      { y: 15, autoAlpha: 0, stagger: 0.175 },
      1.5
    );

  if (isRM) {
    heroTL.pause().progress(1);

    return;
  }

  // follows
  const jumperXTo = gsap.quickTo('.home-hero__jumper', 'x', {
    duration: 0.9,
    ease: 'sine'
  });
  const jumperYTo = gsap.quickTo('.home-hero__jumper', 'y', {
    duration: 0.9,
    ease: 'sine'
  });

  if (homeHero) {
    homeHero.addEventListener('mousemove', (e) => {
      if (e.clientY + window.scrollY <= innerHeight) {
        jumperXTo(gsap.utils.mapRange(0, innerWidth, -20, 20, e.clientX));
        jumperYTo(gsap.utils.mapRange(0, innerHeight, 20, -20, e.clientY));
      }
    });
  }
};

export { init };
